export const iconFontAwesomeEnergyLeaf = (
	<i className="fa-solid fa-leaf"></i>
);
